import { render, staticRenderFns } from "./HeatmapGrouping.vue?vue&type=template&id=820d4756"
import script from "./HeatmapGrouping.vue?vue&type=script&lang=js"
export * from "./HeatmapGrouping.vue?vue&type=script&lang=js"
import style0 from "./HeatmapGrouping.vue?vue&type=style&index=0&id=820d4756&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports